import { Grid2 as Grid, Box} from "@mui/material";

import { Form } from "@shared/components";
import { useTranslate } from "@refinedev/core";
import { AgreementsAutocomplete, LevelsAutocomplete } from "@shared/components/AutocompleteFields";

export function AgreementPlanForm() {
  const translate = useTranslate();

  return (
    <Box
      component="form"
      sx={{ display: "flex", flexDirection: "column" }}
      autoComplete="off"
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="name"
            label={translate("agreement_plans.fields.name")}
            required
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.Autocomplete
            name="type"
            label={translate("agreement_plans.fields.type")}
            options={[]}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <LevelsAutocomplete
            name="level"
            label={translate("agreement_plans.fields.level")}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="uuid"
            label={translate("agreement_plans.fields.uuid")}
            instructions="Gerado automaticamente após criação. Usar na Vindi."
            disabled
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.Input
            name="access_amount"
            label={translate("agreement_plans.fields.access_amount")}
            instructions="Quantidade de acessos liberados após pagamento"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.Input
            name="value"
            label={translate("agreement_plans.fields.value")}
            mask="currency"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.Input
            name="vindi_page"
            label={translate("agreement_plans.fields.vindi_page")}
            instructions="Link da página da Vindi."
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.Input
            name="vindi_token"
            label={translate("agreement_plans.fields.vindi_token")}
            instructions="Token da página da Vindi. (Pode ser encontrado na mesma página do link)"
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <AgreementsAutocomplete
            name="for_agreement"
            label={translate("agreement_plans.fields.for_agreement")}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="slug"
            label={translate("agreement_plans.fields.slug")}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
